import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { LenticMark } from '../LenticMark';
import { ForkDiagram } from './ForkDiagram';
import { EYEBROW } from './Band';
import { heroCommitments } from '../../data/site';
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-bone" data-id="element-166" data-mp="9n16i8qjtsq4">
      <div className="pointer-events-none absolute -right-40 -top-32 opacity-[0.12] lg:-right-20" data-id="element-167" data-mp="9oucdltc88x2">
        <LenticMark size={620} title={null} data-id="element-168" data-mp="12b6sszx93ps2" />
      </div>

      <div className="relative mx-auto grid w-full max-w-7xl gap-14 px-6 pb-24 pt-20 lg:grid-cols-[0.78fr_1.22fr] lg:items-center lg:gap-14 lg:px-10 lg:pb-28 lg:pt-24" data-id="element-169" data-mp="12chyx6e659mc">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-170" data-mp="sm5ede6ctgg7">
          <p className={`inline-flex items-center rounded-full border border-mist bg-white/60 px-3.5 py-1.5 ${EYEBROW} text-teal`} data-id="element-171" data-mp="1l9rjiqv8ct56">
            Hiring signal for the AI workplace
          </p>

          <h1 className="mt-5 font-display text-[32px] font-light leading-[1.05] tracking-tight text-ink sm:text-[46px] lg:text-[60px]" data-id="element-172" data-mp="3nj3rnaeau0oi">
            <span className="block" data-id="element-173" data-mp="39r71vd03s2va">Assume the AI.</span>
            <span className="block" data-id="element-174" data-mp="3epqpdhuchmpr">Provide the AI.</span>
            <span className="block whitespace-nowrap font-medium text-teal" data-id="element-175" data-mp="3eo77xnwyd5me">
              Measure what's left.
            </span>
          </h1>

          <p className="mt-7 max-w-[46ch] text-lg leading-relaxed text-graphite sm:text-xl" data-id="element-176" data-mp="34smam32twtiz">
            AI makes polished candidate output cheap. Lentic gives candidates
            the AI they'll use at work, then measures what they verify,
            challenge and rely on when the answer isn't enough.
          </p>

          <p className="mt-5 max-w-[46ch] text-base leading-relaxed text-muted" data-id="element-177" data-mp="p1rfcu7x30bg">
            Candidates work with AI and source documents in a browser. Lentic
            records how they use the evidence and produces a Decision Record.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-178" data-mp="nkawtuua9ss2">
            <a href="#contact" className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 text-base font-semibold text-bone transition-colors hover:bg-teal" data-id="element-179" data-mp="nm5ijbddpox7">
              Book a walkthrough
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-180" data-mp="dnzfgqfu6cqr" />
            </a>
            <a href="#record" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-7 py-4 text-base font-semibold text-ink transition-colors hover:border-ink/40" data-id="element-181" data-mp="1b8u2e2ly7rgg">
              See what's in a decision record
            </a>
          </div>
        </motion.div>

        <ForkDiagram data-id="element-182" data-mp="wk7pe7jsnbse" />
      </div>

      <div className="relative border-y border-mist bg-white/50" data-id="element-183" data-mp="1u04swinri27t">
        <div className="mx-auto w-full max-w-6xl px-6 py-6 lg:px-10" data-id="element-184" data-mp="1u1pqyi9ac3af">
          <dl className="flex flex-wrap items-center gap-x-4 gap-y-3" data-id="element-185" data-mp="1p8dch0yblcve">
            <dt className={`${EYEBROW} text-graphite`} data-id="element-186" data-mp="1wkt046xgh75s">The Lentic standard</dt>
            {heroCommitments.map((item, i) => <dd key={item.value} className="flex items-center gap-4 text-base text-ink" data-id="element-187" data-mp="21j4bim3efpq4" data-mpi={i}>
                {i > 0 ? <span className="text-mist" aria-hidden="true" data-id="element-188" data-mp="26i7f023qdnvz">·</span> : <span className="hidden text-mist sm:inline" aria-hidden="true" data-id="element-189" data-mp="26ktpoalx4jif">·</span>}
                {item.value}
              </dd>)}
          </dl>
        </div>
      </div>
    </section>;
}